import {Route,Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import { selectAuthenticated, selectProfiles, selectCurrentProfile} from '@src/store/selectors';

const ProtectedRoute=({component:Component, isAuthenticated, profiles, currentProfile , path, ...args})=>{


    const getRender=(props)=>( 
        !isAuthenticated? <Redirect to='/welcome'/>
        : !profiles.length ? <Redirect to= '/add-profile' />
        : !currentProfile ? <Redirect to= '/profiles' />
        // : !currentProfile.currentLevel ? <Redirect to='/levels' />
        : <Component {...props}/>   
        ) ;



    return (
        <Route render={getRender} {...args} />
    )
}

const mapStateToProps=(state)=>{
    return {
        isAuthenticated: selectAuthenticated( state ),
        profiles: selectProfiles( state ),
        currentProfile: selectCurrentProfile( state )
    }
}


export default connect(mapStateToProps)(ProtectedRoute);